import * as Inventory from '.';

import { createMessage, SB } from '@play-co/replicant';
import createMessages from '../config/messages/createMessages';
import { getDummyAPI } from './inventory.utils';

export const inventoryMessages = createMessages({
  /**
   * Add free gems to target user state
   */
  addFreeGems: createMessage(SB.number(), (state, amount) => {
    Inventory.modifiers.addFreeGems(
      state,
      amount,
      { feature: 'message' },
      getDummyAPI(),
    );
  }),
});
